export default "__VITE_ASSET__3EOVLUH1__"